import Vue from "vue";
import Buefy from "buefy";

import ProductPublicDetail from "./App.vue";
import Gallery from "./components/Gallery.vue"


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(ProductPublicDetail)
Vue.use(Gallery)


if(document.getElementById("productPublicDetailApp")){
    new Vue({
        render:h=>h(
            ProductPublicDetail,{
                props:{
                    prodUrl:document.getElementById("productPublicDetailApp").getAttribute("prodUrl"),
                    cartItemUrl:document.getElementById("productPublicDetailApp").getAttribute("cartItemUrl"),
                    cartDetail:document.getElementById("productPublicDetailApp").getAttribute("cartDetail"),
                    shipmentListUrl:document.getElementById("productPublicDetailApp").getAttribute("shipment-list-url"),
                    classifiedUrl:document.getElementById("productPublicDetailApp").getAttribute("classified-url"),
                    authUser:document.getElementById("productPublicDetailApp").getAttribute("auth-user"),
                    mpChannel:document.getElementById("productPublicDetailApp").getAttribute("mpChannel"),
                    displaySku:document.getElementById("productPublicDetailApp").getAttribute("display-sku"),
                    checkoutTemplate:document.getElementById("productPublicDetailApp").getAttribute("checkoutTemplate"),
                    relatedProductsUrl:document.getElementById("productPublicDetailApp").getAttribute("relatedProductsUrl"),
                }
            }
        )
    }).$mount("#productPublicDetailApp")
}